import { render, staticRenderFns } from "./Transaction.vue?vue&type=template&id=b124a53c"
import script from "./Transaction.vue?vue&type=script&lang=js"
export * from "./Transaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b124a53c')) {
      api.createRecord('b124a53c', component.options)
    } else {
      api.reload('b124a53c', component.options)
    }
    module.hot.accept("./Transaction.vue?vue&type=template&id=b124a53c", function () {
      api.rerender('b124a53c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/driver/components/Transaction.vue"
export default component.exports